/* src/app/core/auth/login/login.component.scss */
:root {
  --main-bg-image: url(/);
  --popup-bg-image: url(/);
  --color-white: #ffffff;
  --color-white-a50: #ffffff80;
  --color-white-a95: #fffffff2;
  --color-black: #333333;
  --color-black-a10: #3333331a;
  --color-primary: #202020;
  --color-primary-a95: #202020f2;
  --color-primary-a50: #20202080;
  --color-primary-a06: #2020200f;
  --color-nav-mobile-shade: #202020b3;
  --color-secondary: #89674a;
  --color-secondary-light: #c7b289;
  --color-secondary-lighter: #f2efe5;
  --color-secondary-lighter-a50: #f2efe580;
  --color-secondary-lighter-a95: #f2efe5f2;
  --color-secondary-xlight: #fdfbf3;
  --color-secondary-xlight-a95: #fdfbf3f2;
  --color-success: #8bc34a;
  --color-warning: #fc7c64;
  --color-danger: #df1642;
  --color-danger-light: #fce7ec;
  --color-dark: #202020;
  --color-xlight: #ccc;
  --color-xxlight: #eee;
  --backdrop-filter: blur(5px);
  --line-height-base: 1.5;
  --navbar-open-width: 280px;
  --header-height: 0;
  --header-help-height: 63px;
  --border-radius-small: 4px;
  --border-radius-base: 8px;
  --border-radius-large: 10px;
  --border-radius-xl: 30px;
  --container-max-width: 1200px;
  --container-max-width-2: 100%;
  --container-max-width-3: 1500px;
  --font-primary: "Inter", sans-serif;
  --font-secondary: "Trust", serif;
  --font-size-small: 13px;
  --font-size-base: 16px;
  --font-size-17: 17px;
  --font-size-large: 18px;
  --font-size-xl: 24px;
  --font-size-xxl: 28px;
  --font-size-h2: 35px;
  --font-size-h1: 35px;
  --xs_btn_size: 22px;
  --sm_btn_size: 36px;
  --md_btn_size: 41px;
  --lg_btn_size: 48px;
  --xl_btn_size: 51px;
  --xxl_btn_size: 60px;
  --xs_btn_size_font: 12px;
  --sm_btn_size_font: 14px;
  --md_btn_size_font: 16px;
  --lg_btn_size_font: 16px;
  --xl_btn_size_font: 18px;
  --xxl_btn_size_font: 20px;
  --adda-css-var-color-white: #fff;
  --adda-css-var-color-white-a25: #ffffff3f;
  --adda-css-var-color-white-a50: #ffffff80;
  --adda-css-var-color-xxlight: #f6f7f9;
  --adda-css-var-color-xlight: #e5e7ee;
  --adda-css-var-color-xlight-a60: #e5e7ee98;
  --adda-css-var-color-light-blue: #dfd7e1;
  --adda-css-var-color-light-blue-a50: #dfd7e180;
  --adda-css-var-color-light-blue-2: #00dcff;
  --adda-css-var-color-light-blue-2-a50: #00dcff80;
  --adda-css-var-color-light-grey: #a3b0bf;
  --adda-css-var-color-light-grey-a50: #a3b0bf80;
  --adda-css-var-color-light-red: #ffdcdc;
  --adda-css-var-color-light-red-a50: #ffdcdc80;
  --adda-css-var-color-yellow: #eec61f;
  --adda-css-var-color-yellow-a06: #eec61f0f;
  --adda-css-var-color-yellow-a10: #eec61f1a;
  --adda-css-var-color-yellow-a25: #eec61f3f;
  --adda-css-var-color-yellow-a50: #eec61f80;
  --adda-css-var-color-light-orange: #fc7c64;
  --adda-css-var-color-light-orange-a06: #fc7c640f;
  --adda-css-var-color-light-orange-a10: #fc7c641a;
  --adda-css-var-color-light-orange-a25: #fc7c643f;
  --adda-css-var-color-light-orange-a50: #fc7c6480;
  --adda-css-var-color-green: #23c399;
  --adda-css-var-color-green-a06: #23c3990f;
  --adda-css-var-color-green-a10: #23c3991a;
  --adda-css-var-color-green-a25: #23c3993f;
  --adda-css-var-color-green-a50: #23c39980;
  --adda-css-var-color-light-green: #aaf0aa;
  --adda-css-var-color-light-green-a50: #aaf0aa80;
  --adda-css-var-color-medium: #8f7496;
  --adda-css-var-color-medium-a06: #8f74960f;
  --adda-css-var-color-medium-a10: #8f74961a;
  --adda-css-var-color-medium-a25: #8f74963f;
  --adda-css-var-color-medium-a50: #8f749680;
  --adda-css-var-color-medium-light: #a996b0;
  --adda-css-var-color-dark: #42304d;
  --adda-css-var-color-dark-a50: #42304d80;
  --adda-css-var-color-darker: #2d1939;
  --adda-css-var-color-black: #1e1e1e;
  --adda-css-var-color-blue: #0f6ea8;
  --adda-css-var-color-blue-a06: #0f6ea80f;
  --adda-css-var-color-blue-a25: #0f6ea83f;
  --adda-css-var-color-blue-a50: #0f6ea880;
  --adda-css-var-color-aqua: #7bdbc2;
  --adda-css-var-color-aqua-a25: #7bdbc23f;
  --adda-css-var-color-aqua-a50: #7bdbc280;
  --adda-css-var-color-bright-blue: #37baf6;
  --adda-css-var-color-bright-blue-a50: #37baf680;
  --adda-css-var-color-purple: #8f76e5;
  --adda-css-var-color-purple-a50: #8f76e580;
  --adda-css-var-color-red: #df1642;
  --adda-css-var-color-red-a06: #df16420f;
  --adda-css-var-color-red-a10: #df16421a;
  --adda-css-var-color-red-a25: #df16423f;
  --adda-css-var-color-red-a50: #df164280;
  --adda-css-var-color-low: var(--adda-css-var-color-medium);
  --adda-css-var-color-low-a10: var(--adda-css-var-color-medium-a10);
  --adda-css-var-color-primary: var(--adda-css-var-color-blue);
  --adda-css-var-color-primary-a06: var(--adda-css-var-color-blue-a06);
  --adda-css-var-color-primary-a25: var(--adda-css-var-color-blue-a25);
  --adda-css-var-color-primary-a50: var(--adda-css-var-color-blue-a50);
  --adda-css-var-color-secondary: var(--adda-css-var-color-aqua);
  --adda-css-var-color-secondary-a25: var(--adda-css-var-color-aqua-a25);
  --adda-css-var-color-secondary-a50: var(--adda-css-var-color-aqua-a50);
  --adda-css-var-color-success: var(--adda-css-var-color-green);
  --adda-css-var-color-success-a06: var(--adda-css-var-color-green-a06);
  --adda-css-var-color-success-a10: var(--adda-css-var-color-green-a10);
  --adda-css-var-color-success-a25: var(--adda-css-var-color-green-a25);
  --adda-css-var-color-success-a50: var(--adda-css-var-color-green-a50);
  --adda-css-var-color-warning: var(--adda-css-var-color-yellow);
  --adda-css-var-color-warning-a06: var(--adda-css-var-color-yellow-a06);
  --adda-css-var-color-warning-a10: var(--adda-css-var-color-yellow-a10);
  --adda-css-var-color-warning-a25: var(--adda-css-var-color-yellow-a25);
  --adda-css-var-color-warning-a50: var(--adda-css-var-color-yellow-a50);
  --adda-css-var-color-high: var(--adda-css-var-color-light-orange);
  --adda-css-var-color-high-a06: var(----adda-css-var-color-light-orange-a06);
  --adda-css-var-color-high-a10: var(----adda-css-var-color-light-orange-a10);
  --adda-css-var-color-high-a25: var(----adda-css-var-color-light-orange-a25);
  --adda-css-var-color-high-a50: var(----adda-css-var-color-light-orange-a50);
  --adda-css-var-color-danger: var(--adda-css-var-color-red);
  --adda-css-var-color-danger-a06: var(--adda-css-var-color-red-a06);
  --adda-css-var-color-danger-a10: var(--adda-css-var-color-red-a10);
  --adda-css-var-color-danger-a25: var(--adda-css-var-color-red-a25);
  --adda-css-var-color-danger-a50: var(--adda-css-var-color-red-a50);
  --adda-css-var-line-height-base: 1.7;
  --adda-css-var-navbar-close-width: 64px;
  --adda-css-var-navbar-open-width: 210px;
  --adda-css-var-rightbar-open-width: 510px;
  --adda-css-var-topbar-height: 54px;
  --adda-css-var-border-radius-base: 4px;
  --adda-css-var-border-radius-large: 8px;
  --adda-css-var-xs_btn_size: 22px;
  --adda-css-var-sm_btn_size-2: 28px;
  --adda-css-var-sm_btn_size: 36px;
  --adda-css-var-md_btn_size: 43px;
  --adda-css-var-lg_btn_size: 49px;
  --adda-css-var-xl_btn_size: 51px;
  --adda-css-var-xxl_btn_size: 60px;
  --adda-css-var-xs_btn_size_font: 12px;
  --adda-css-var-sm_btn_size_font: 14px;
  --adda-css-var-md_btn_size_font: 16px;
  --adda-css-var-lg_btn_size_font: 16px;
  --adda-css-var-xl_btn_size_font: 18px;
  --adda-css-var-xxl_btn_size_font: 20px;
  --adda-css-var-container-max-width: 1100px;
  --adda-css-var-left-inner-navigation-close-width: 0;
  --adda-css-var-left-inner-navigation-open-width: 250px;
}
@media (max-width: 1200px) {
  :root {
    --header-height: 63px;
  }
}
:host {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
:host .wrapper {
  grid-area: content;
  width: 100%;
  max-width: 540px;
  margin: auto;
  padding: 10px;
}
@media (max-width: 800px) {
  :host .wrapper {
    padding-top: 20px;
  }
}
:host .wrapper .logo {
  margin: 0px auto 10px;
  width: 220px;
}
:host .wrapper .logo .logo-top {
  width: 70px;
  margin: 0 auto 10px;
}
:host .wrapper .logo .logo-bot {
  margin: 0 auto;
  width: 220px;
}
:host .auth {
  width: 100%;
  border-radius: var(--border-radius-xl);
  transition: all 0.2s;
  -webkit-backdrop-filter: var(--backdrop-filter);
  backdrop-filter: var(--backdrop-filter);
  background: var(--color-white-a95) url("./media/bombardier-pattern-TKTLLAXU.svg") no-repeat left bottom;
  background-size: 700px;
  background-position: bottom -55px left 0;
}
:host .auth .dx-button-content {
  padding: 10px 30px;
}
:host .login-form {
  padding: 40px 50px;
}
@media (max-width: 768px) {
  :host .login-form {
    padding: 40px 20px;
  }
}
:host .login-form .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;
  border-bottom: 1px dashed var(--color-secondary-light);
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 30px;
}
:host .login-form .logo img {
  width: auto;
  height: 80px;
  object-fit: contain;
}
:host .login-form .title {
  margin: 0 0 35px 0;
  text-align: center;
  font-size: 30px !important;
  color: var(--color-secondary);
  font-family: var(--font-secondary);
}
:host .login-form .form-group + .form-group {
  margin-top: 20px;
}
:host .login-form label {
  font-size: 15px;
  color: var(--color-primary);
}
:host .login-form .submit {
  margin-top: 50px;
  margin-bottom: 30px;
}
:host .login-form .error-message {
  font-size: 14px;
  padding: 3px 10px;
  color: var(--color-danger);
}
:host .login-form .forgot-password {
  margin: 30px auto 0;
  text-align: center;
}
:host .login-form .forgot-password a {
  font-size: 17px;
  color: var(--color-danger);
  text-decoration: underline;
}
:host .login-form .disclaimer {
  padding: 20px 10px 0px;
  font-size: 14px;
}
/*# sourceMappingURL=login.component-IPYUDDNP.css.map */
